import { createContext, useContext, useEffect, useState } from "react";
import { ToastStyled, StyledLinearProgress } from "./toastStyles.js";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import { CloseIcon } from "./CloseIcon";

const ToastContext = createContext();
const DURATION = 2500;
const ICON = "ECIconGear";

export const Toast = ({ children }) => {
  const [open, setOpen] = useState(false);

  const [message, setMessage] = useState({
    message: "",
    meta: "",
    duration: DURATION,
    icon: ICON,
    type: "",
    hiddenCloseButton: false
  });

  const showToast = ({ icon = ICON, duration, ...rest }) => {
    setOpen(false);
    const dur = setTimeout(() => {
      setMessage({ duration: duration || DURATION, icon, ...rest });
      setOpen(true);
    }, 300);
    return () => clearTimeout(dur);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <ToastStyled
        open={open}
        autoHideDuration={message.duration}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Stack
          style={{
            height: "100%",
            padding: "0",
            display: "flex",
            flexDirection: "column",
            backgroundColor: "var(--container-main)"
          }}
        >
          <Stack
            style={{
              width: "85%",
              gap: "10px"
            }}
          >
            <div className="text-parent">
              <Typography
                variant="span"
                className="meta"
                style={{
                  fontSize: "10px",
                  color: "var(--text-primary)"
                }}
              >
                {message.meta}
              </Typography>
              <Typography
                className="message"
                style={{
                  fontSize: "14px",
                  color: "var(--text-primary)",
                  padding: "10px 0"
                }}
                variant="span"
              >
                {message.message}
              </Typography>
            </div>

            {!message.hiddenCloseButton && (
              <CloseIcon
                sx={{ cursor: "pointer" }}
                color={"var(--text-primary)"}
                fontSize="small"
                onClick={handleClose}
              />
            )}
          </Stack>
          {message.type && <LinearProgress message={message} />}
        </Stack>
      </ToastStyled>
    </ToastContext.Provider>
  );
};

const LinearProgress = ({ message }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prevProgress) => prevProgress + 0.22);
    }, 10);

    const duration = setTimeout(() => {
      clearInterval(interval);
      setProgress(0);
    }, message.duration);

    return () => {
      clearTimeout(duration);
    };
  }, []);

  return (
    <div
      style={{
        width: "100%",
        borderBottomRightRadius: "8px",
        borderBottomLeftRadius: "8px",
        overflow: "hidden"
      }}
    >
      <StyledLinearProgress
        color={message.type}
        value={progress}
        valueBuffer={progress}
        variant="determinate"
      />
    </div>
  );
};

export const onShowToast = () => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error("useSnackbar must be used within a SnackbarProvider");
  }
  return context;
};

// Toast.propTypes = {
//   icon: PropTypes.string,
//   type: PropTypes.oneOf[("success", "warning", "error")]
// };
